import useCheckAuth from '../hooks/auth/useCheckAuth.js';
import '../css/pages/Home.css';
import imgHome from '../images/home/wellcome.svg';

export default function Home() {
    const { user, error } = useCheckAuth();        
    
    return (
        <>                       
            <section id="hero" className="d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1" data-aos="fade-up" data-aos-delay="200">
                            <h1>¡Bienvenido!</h1>
                            <h2>
                                {error ? error : user ? (
                                    <>                                 
                                        {`${user.name} ${user.lastname}`} 
                                    </> 
                                ) : ''
                                }
                            </h2>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2 hero-img text-center mt-4" data-aos="zoom-in" data-aos-delay="200">                                                                                
                                <img src={imgHome} className="img-fluid animated" loading="lazy" alt="Imagen Home" />
                        </div>
                    </div>
                </div>
            </section>            
        </>
    );
}